import { render, staticRenderFns } from "./PaymentProvidersTableComponent.vue?vue&type=template&id=cd7b6bfa&"
import script from "./PaymentProvidersTableComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentProvidersTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports